<template>
  <FlexColumn>
    <Label bold text="希望条件" />
    <FlexColumn>
      <Label v-if="prefectures" :text="`勤務地：${prefectures}`" />
      <Label v-if="remoteWork" :text="`リモートワーク希望：${remoteWork}`" />
      <template v-if="side">
        <Label v-if="hourlyWage" :text="`希望時間単価：${hourlyWage}`" />
        <Label v-if="workingHoursWeek" :text="`希望勤務時間：${workingHoursWeek}`" />
        <FlexRow v-if="availability">
          <Label :text="`希望勤務時間帯：`"/>
          <Label v-if="availabilityDaytime" :text="`平日昼：${availabilityDaytime}`" />
          <Label v-if="availabilityEvening" :text="`平日夜：${availabilityEvening}`" />
          <Label v-if="availabilityHoliday" :text="`土日祝：${availabilityHoliday}`" />
        </FlexRow>
      </template>
    </FlexColumn>
  </FlexColumn>
</template>

<script>
import FlexColumn from "@/components/atoms/FlexColumn";
import Label from "@/components/atoms/Label";
import {mapGetters} from "vuex";
import ComponentMixin from "../ComponentMixin";
import FlexRow from "../atoms/FlexRow";
export default {
  mixins: [ComponentMixin],
  name: "ApplicantDesiredConditions",
  components: {FlexRow, Label, FlexColumn},
  props: {
    applicant: {
      type: Object
    },
    targetJob: {
      type: Object
    }
  },
  computed: {
    ...mapGetters('system', ['consts']),
    prefectures() {
      return this.applicant.conditions.prefectures.map(prefecture => this.prefectureName(prefecture)).join('、')
    },
    remoteWork() {
      return this.applicant.conditions.remoteWork ? 'フルリモートのみ' : 'なし'
    },
    regular() {
      return !this.targetJob.isSide
    },
    side() {
      return this.targetJob.isSide
    },
    hourlyWage() {
      return this.constsToText(this.applicant.conditions.hourlyWage, this.consts.hourlyWedgeRange)
    },
    workingHoursWeek() {
      return this.constsToText(this.applicant.conditions.workingHoursWeek, this.consts.workingHoursRange)
    },
    availability() {
      return this.availabilityDaytime != "" || this.availabilityEvening != "" || this.availabilityHoliday != ""
    },
    availabilityDaytime() {
      return this.constsToText(this.applicant.conditions.availabilityDaytime, this.availabilityTimeList)
    },
    availabilityEvening() {
      return this.constsToText(this.applicant.conditions.availabilityEvening, this.availabilityTimeList)
    },
    availabilityHoliday() {
      return this.constsToText(this.applicant.conditions.availabilityHoliday, this.availabilityTimeList)
    },
    availabilityTimeList() {
      return [
        { label: '実働可', value: 1 },
        { label: '連絡可', value: 2 },
        { label: '連絡不可', value: 3 },
      ]
    },
  },
  methods: {
    prefectureName(value) {
      if (this.consts.prefectures) {
        return this.consts.preferredLocation.find(prefecture => prefecture.value === value).label
      }
    },
  }
}
</script>

<style scoped>

</style>